import { createAction, props } from '@ngrx/store';
import { DefaultConfig } from '../../model/default-config.model';
import AppError from '../../model/app-error';
import { GlobtroterUserResult, GlobtroterMenuResult, GlobtroterConfigResult } from '../../model/globtroter-config';

export enum ConfigActions {
  FetchStart = '[Config] Fetch Start',
  FetchSuccess = '[Config] Fetch Success',
  FetchError = '[Config] Fetch Error',
  FetchMenuConfigStart = '[Config] Fetch Menu Config Start',
  FetchMenuConfigSuccess = '[Config] Fetch Menu Config Success',
  FetchMenuConfigError = '[Config] Fetch Menu Config Error',
  FetchGlobtroterUserStart = '[Config] Fetch Globtroter User Start',
  FetchGlobtroterUserSuccess = '[Config] Fetch Globtroter User Success',
  FetchGlobtroterUserError = '[Config] Fetch Globtroter User Error',
  FetchGlobtroterConfigStart = '[Config] Fetch Globtroter Config Start',
  FetchGlobtroterConfigSuccess = '[Config] Fetch Globtroter Config Success',
  FetchGlobtroterConfigError = '[Config] Fetch Globtroter Config Error',
}

const fetchStart = createAction(ConfigActions.FetchStart);
const fetchSuccess = createAction(ConfigActions.FetchSuccess, props<{ data: DefaultConfig }>());
const fetchError = createAction(ConfigActions.FetchError, props<{ error: AppError }>());
const fetchMenuConfigStart = createAction(ConfigActions.FetchMenuConfigStart);
const fetchMenuConfigSuccess = createAction(ConfigActions.FetchMenuConfigSuccess, props<{ data: GlobtroterMenuResult }>());
const fetchMenuConfigError = createAction(ConfigActions.FetchMenuConfigError, props<{ error: AppError }>());
const fetchGlobtroterUserStart = createAction(ConfigActions.FetchGlobtroterUserStart);
const fetchGlobtroterUserSuccess = createAction(ConfigActions.FetchGlobtroterUserSuccess, props<{ data: GlobtroterUserResult }>());
const fetchGlobtroterUserError = createAction(ConfigActions.FetchGlobtroterUserError, props<{ error: AppError }>());
const fetchGlobtroterConfigStart = createAction(ConfigActions.FetchGlobtroterConfigStart);
const fetchGlobtroterConfigSuccess = createAction(ConfigActions.FetchGlobtroterConfigSuccess, props<{ data: GlobtroterConfigResult }>());
const fetchGlobtroterConfigError = createAction(ConfigActions.FetchGlobtroterConfigError, props<{ error: AppError }>());

const configActions = {
  fetchStart,
  fetchSuccess,
  fetchError,
  fetchMenuConfigStart,
  fetchMenuConfigSuccess,
  fetchMenuConfigError,
  fetchGlobtroterUserStart,
  fetchGlobtroterUserSuccess,
  fetchGlobtroterUserError,
  fetchGlobtroterConfigStart,
  fetchGlobtroterConfigSuccess,
  fetchGlobtroterConfigError,
};

export default configActions;
